import React from 'react'
import Protypes from 'prop-types'

export const NumberIcon = ({ number, zoom }) => (
  <div className="rmc-number" id={'boundingBoxClass_' + number} >
    {number}
    <style jsx>{`
    .rmc-number {
      height: ${zoom + 3}px;
      float: left;
      font-size: ${zoom}px;
      background:#262626;
      text-align: center;
      line-height: ${zoom + 3}px;
      color: white;
      opacity: 1;
    }           
  `}
    </style>
  </div>
)


const { number } = Protypes

NumberIcon.propTypes = {
  number
}

NumberIcon.defaultProps = {
  number: '',
}

